import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";

const duplicateVisit = async ({ trialId, visitNumber, count, startNumber, namePrefix }) => {
  const token = localStorage.getItem("token");

  const response = await axios.post(
    `${__API_URL__}/api/photos/duplicate_visit/${trialId}/`,
    {
      visit_number: visitNumber,
      count,
      start_number: startNumber,
      name_prefix: namePrefix,
    },
    {
      headers: {
        Authorization: `Token ${token}`,
      },
    }
  );

  return response.data;
};

const useDuplicateVisitMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: duplicateVisit,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["visits"] });
    },
  });
};

export default useDuplicateVisitMutation;
